import { Filter } from '@spoiler-alert/ui-library';
import { makeAutoObservable } from 'mobx';
import type { OfferCompFilters } from '../pages/offer-comparison/offer-comparison-filter-operations';

const localStorageKey = 'usersFilter';

type FilterTypes =
  | 'myClaims'
  | 'myPosts'
  | 'inventoryTable'
  | 'catalog'
  | 'negotiationsDetail'
  | 'offerComparison'
  | 'trucklane'
  | 'sellerReviewOffer'
  | 'stagingDetail'
  | 'donationsStagingDetail'
  | 'transactionHistory'
  | 'transactions'
  | 'suggestedNegotiations'
  | 'negotiationDetails';

type FilterValues = Record<Exclude<FilterTypes, 'offerComparison'>, Filter[]> & { offerComparison: OfferCompFilters };

class UserFiltersStore {
  filters: FilterValues = JSON.parse(localStorage.getItem(localStorageKey) as string) || {};

  constructor() {
    makeAutoObservable(this);
  }

  updateFilters<T extends FilterTypes>(name: T, val: FilterValues[T]): void {
    this.filters[name] = val;
    localStorage.setItem(localStorageKey, JSON.stringify(this.filters));
  }
}

export default UserFiltersStore;
